import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LoanSummary, LoanTerms } from "@/components/loan/LoanSummary";
import { OnlinePayments } from "@/components/loan/OnlinePayments";
import { ScheduleTable, PaymentsTable, LedgerTable, FeesTable } from "@/components/loan/LoanTables";
import { StatementsPanel } from "@/components/loan/StatementsPanel";
import { ActivityLog } from "@/components/loan/ActivityLog";
import { EmailLog } from "@/components/loan/EmailLog";

export const LoanDetailView = ({ data, readOnly, onEdit, onVoid, onWaive, statementsKey = 0 }) => {
  const posted = data.payments.filter((p) => p.status === "posted").length;
  const tabs = [["schedule", `Schedule (${data.schedule.length})`], ["payments", `Payments (${posted})`],
    ...(readOnly ? [] : [["ledger", "Ledger"]]), ["fees", `Late fees (${data.fees.length})`], ["statements", "Statements"],
    ...(readOnly ? [] : [["activity", "Activity"], ["emails", "Emails"]])];
  return (
    <div className="space-y-6">
      <LoanSummary loan={data.loan} summary={data.summary} />
      <OnlinePayments loanId={data.loan.id} refreshKey={data} />
      <div className="grid gap-6 xl:grid-cols-[1fr_320px]">
        <div className="fade-up min-w-0 rounded-lg border bg-card" style={{ animationDelay: "80ms" }}>
          <Tabs defaultValue="schedule">
            <div className="overflow-x-auto border-b px-4 pt-4 sm:px-6">
              <TabsList className="h-auto gap-1 bg-transparent p-0">
                {tabs.map(([v, l]) => (
                  <TabsTrigger key={v} value={v} data-testid={`tab-${v}`}
                    className="rounded-none border-b-2 border-transparent px-3 pb-3 pt-1 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none">
                    {l}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>
            <TabsContent value="schedule" className="mt-0"><ScheduleTable rows={data.schedule} /></TabsContent>
            <TabsContent value="payments" className="mt-0"><PaymentsTable payments={data.payments} readOnly={readOnly} onEdit={onEdit} onVoid={onVoid} /></TabsContent>
            {!readOnly && <TabsContent value="ledger" className="mt-0"><LedgerTable entries={data.ledger} /></TabsContent>}
            <TabsContent value="fees" className="mt-0"><FeesTable fees={data.fees} readOnly={readOnly} onWaive={onWaive} /></TabsContent>
            <TabsContent value="statements" className="mt-0"><StatementsPanel loanId={data.loan.id} readOnly={readOnly} refreshKey={statementsKey} /></TabsContent>
            {!readOnly && <TabsContent value="activity" className="mt-0"><ActivityLog loanId={data.loan.id} refreshKey={data} /></TabsContent>}
            {!readOnly && <TabsContent value="emails" className="mt-0"><EmailLog loanId={data.loan.id} refreshKey={data} /></TabsContent>}
          </Tabs>
        </div>
        <div className="xl:order-none"><LoanTerms loan={data.loan} summary={data.summary} /></div>
      </div>
    </div>
  );
};
